import * as t from "io-ts";
import { fetchJSON } from "./fetchJSON";
const TOPOJSON = "/static/stadt-zurich.json";
const Topojson = t.interface({
    type: t.string,
    bbox: t.any,
    transform: t.any,
    objects: t.dictionary(t.string, t.object),
    arcs: t.any
}, "Topojson");
export const fetchTopojson = () => fetchJSON({
    url: TOPOJSON,
    decode: topojson => {
        return Topojson.decode(topojson);
    }
});
/** Map between SSZ geo IDs -> ids used in the topojson file */
export const GEO_IDS_MAP = new Map([
    /** Quartiere */
    ["R00011", "11"],
    ["R00012", "12"],
    ["R00013", "13"],
    ["R00014", "14"],
    ["R00021", "21"],
    ["R00023", "23"],
    ["R00024", "24"],
    ["R00031", "31"],
    ["R00033", "33"],
    ["R00034", "34"],
    ["R00041", "41"],
    ["R00042", "42"],
    ["R00044", "44"],
    ["R00051", "51"],
    ["R00052", "52"],
    ["R00061", "61"],
    ["R00063", "63"],
    ["R00071", "71"],
    ["R00072", "72"],
    ["R00073", "73"],
    ["R00074", "74"],
    ["R00081", "81"],
    ["R00082", "82"],
    ["R00083", "83"],
    ["R00091", "91"],
    ["R00092", "92"],
    ["R00101", "101"],
    ["R00102", "102"],
    ["R00111", "111"],
    ["R00115", "115"],
    ["R00119", "119"],
    ["R00121", "121"],
    ["R00122", "122"],
    ["R00123", "123"],
    /** Kreise */
    ["R10000", "1"],
    ["R00200", "2"],
    ["R00600", "3"],
    ["R00700", "4"],
    ["R00800", "5"],
    ["R01200", "6"],
    ["R01300", "7"],
    ["R01100", "8"],
    ["R01400", "9"],
    ["R01500", "10"],
    ["R01800", "11"],
    ["R01700", "12"]
    /** Wahlkreise */
    /** Statistische Zonen */
]);



// WEBPACK FOOTER //
// ./src/api/topojson.ts